// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../../shared/constants/input.constants';
import { SRQCompleted } from '../../shared/model/srq-completed.model';
import { SRQCompletedService } from './srq-completed.service';
import { UserService } from '../../core/user/user.service';
import * as i0 from "@angular/core";
import * as i1 from "./srq-completed.service";
import * as i2 from "../../core/user/user.service";
import * as i3 from "@angular/router";
import * as i4 from "@angular/forms";
import * as i5 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i6 from "../../shared/alert/alert-error.component";
import * as i7 from "@angular/common";
import * as i8 from "@fortawesome/angular-fontawesome";
function SRQCompletedUpdateComponent_option_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const userOption_r1 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngValue", userOption_r1.id === (ctx_r0.editForm.get("user").value == null ? null : ctx_r0.editForm.get("user").value.id) ? ctx_r0.editForm.get("user").value : userOption_r1);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(userOption_r1.login);
} }
export class SRQCompletedUpdateComponent {
    constructor(sRQCompletedService, userService, activatedRoute, fb) {
        this.sRQCompletedService = sRQCompletedService;
        this.userService = userService;
        this.activatedRoute = activatedRoute;
        this.fb = fb;
        this.isSaving = false;
        this.users = [];
        this.editForm = this.fb.group({
            id: [],
            dateTaken: [],
            score: [],
            bodyScore: [],
            moodScore: [],
            energyScore: [],
            outlookScore: [],
            user: []
        });
    }
    ngOnInit() {
        this.activatedRoute.data.subscribe(({ sRQCompleted }) => {
            if (!sRQCompleted.id) {
                const today = moment().startOf('day');
                sRQCompleted.dateTaken = today;
            }
            this.updateForm(sRQCompleted);
            this.userService.query().subscribe((res) => (this.users = res.body || []));
        });
    }
    updateForm(sRQCompleted) {
        this.editForm.patchValue({
            id: sRQCompleted.id,
            dateTaken: sRQCompleted.dateTaken ? sRQCompleted.dateTaken.format(DATE_TIME_FORMAT) : null,
            score: sRQCompleted.score,
            bodyScore: sRQCompleted.bodyScore,
            moodScore: sRQCompleted.moodScore,
            energyScore: sRQCompleted.energyScore,
            outlookScore: sRQCompleted.outlookScore,
            user: sRQCompleted.user
        });
    }
    previousState() {
        window.history.back();
    }
    save() {
        this.isSaving = true;
        const sRQCompleted = this.createFromForm();
        if (sRQCompleted.id !== undefined) {
            this.subscribeToSaveResponse(this.sRQCompletedService.update(sRQCompleted));
        }
        else {
            this.subscribeToSaveResponse(this.sRQCompletedService.create(sRQCompleted));
        }
    }
    createFromForm() {
        return Object.assign(Object.assign({}, new SRQCompleted()), { id: this.editForm.get(['id']).value, dateTaken: this.editForm.get(['dateTaken']).value ? moment(this.editForm.get(['dateTaken']).value, DATE_TIME_FORMAT) : undefined, score: this.editForm.get(['score']).value, bodyScore: this.editForm.get(['bodyScore']).value, moodScore: this.editForm.get(['moodScore']).value, energyScore: this.editForm.get(['energyScore']).value, outlookScore: this.editForm.get(['outlookScore']).value, user: this.editForm.get(['user']).value });
    }
    subscribeToSaveResponse(result) {
        result.subscribe(() => this.onSaveSuccess(), () => this.onSaveError());
    }
    onSaveSuccess() {
        this.isSaving = false;
        this.previousState();
    }
    onSaveError() {
        this.isSaving = false;
    }
    trackById(index, item) {
        return item.id;
    }
}
SRQCompletedUpdateComponent.ɵfac = function SRQCompletedUpdateComponent_Factory(t) { return new (t || SRQCompletedUpdateComponent)(i0.ɵɵdirectiveInject(i1.SRQCompletedService), i0.ɵɵdirectiveInject(i2.UserService), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i4.FormBuilder)); };
SRQCompletedUpdateComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SRQCompletedUpdateComponent, selectors: [["jhi-srq-completed-update"]], decls: 53, vars: 6, consts: [[1, "row", "justify-content-center"], [1, "col-8"], ["name", "editForm", "role", "form", "novalidate", "", 3, "formGroup", "ngSubmit"], ["id", "jhi-srq-completed-heading", "jhiTranslate", "inukaNgApp.sRQCompleted.home.createOrEditLabel"], [1, "form-group", 3, "hidden"], ["for", "id", "jhiTranslate", "global.field.id"], ["type", "text", "id", "id", "name", "id", "formControlName", "id", "readonly", "", 1, "form-control"], [1, "form-group"], ["jhiTranslate", "inukaNgApp.sRQCompleted.dateTaken", "for", "field_dateTaken", 1, "form-control-label"], [1, "d-flex"], ["id", "field_dateTaken", "type", "datetime-local", "name", "dateTaken", "formControlName", "dateTaken", "placeholder", "YYYY-MM-DD HH:mm", 1, "form-control"], ["jhiTranslate", "inukaNgApp.sRQCompleted.score", "for", "field_score", 1, "form-control-label"], ["type", "number", "name", "score", "id", "field_score", "formControlName", "score", 1, "form-control"], ["jhiTranslate", "inukaNgApp.sRQCompleted.bodyScore", "for", "field_bodyScore", 1, "form-control-label"], ["type", "number", "name", "bodyScore", "id", "field_bodyScore", "formControlName", "bodyScore", 1, "form-control"], ["jhiTranslate", "inukaNgApp.sRQCompleted.moodScore", "for", "field_moodScore", 1, "form-control-label"], ["type", "number", "name", "moodScore", "id", "field_moodScore", "formControlName", "moodScore", 1, "form-control"], ["jhiTranslate", "inukaNgApp.sRQCompleted.energyScore", "for", "field_energyScore", 1, "form-control-label"], ["type", "number", "name", "energyScore", "id", "field_energyScore", "formControlName", "energyScore", 1, "form-control"], ["jhiTranslate", "inukaNgApp.sRQCompleted.outlookScore", "for", "field_outlookScore", 1, "form-control-label"], ["type", "number", "name", "outlookScore", "id", "field_outlookScore", "formControlName", "outlookScore", 1, "form-control"], ["jhiTranslate", "inukaNgApp.sRQCompleted.user", "for", "field_user", 1, "form-control-label"], ["id", "field_user", "name", "user", "formControlName", "user", 1, "form-control"], [3, "ngValue"], [3, "ngValue", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["type", "button", "id", "cancel-save", 1, "btn", "btn-secondary", 3, "click"], ["icon", "ban"], ["jhiTranslate", "entity.action.cancel"], ["type", "submit", "id", "save-entity", 1, "btn", "btn-primary", 3, "disabled"], ["icon", "save"], ["jhiTranslate", "entity.action.save"]], template: function SRQCompletedUpdateComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "form", 2);
        i0.ɵɵlistener("ngSubmit", function SRQCompletedUpdateComponent_Template_form_ngSubmit_2_listener() { return ctx.save(); });
        i0.ɵɵelementStart(3, "h2", 3);
        i0.ɵɵtext(4, "Create or edit a SRQ Completed");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div");
        i0.ɵɵelement(6, "jhi-alert-error");
        i0.ɵɵelementStart(7, "div", 4);
        i0.ɵɵelementStart(8, "label", 5);
        i0.ɵɵtext(9, "ID");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(10, "input", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 7);
        i0.ɵɵelementStart(12, "label", 8);
        i0.ɵɵtext(13, "Date Taken");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 9);
        i0.ɵɵelement(15, "input", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 7);
        i0.ɵɵelementStart(17, "label", 11);
        i0.ɵɵtext(18, "Score");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(19, "input", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 7);
        i0.ɵɵelementStart(21, "label", 13);
        i0.ɵɵtext(22, "Body Score");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(23, "input", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div", 7);
        i0.ɵɵelementStart(25, "label", 15);
        i0.ɵɵtext(26, "Mood Score");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(27, "input", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 7);
        i0.ɵɵelementStart(29, "label", 17);
        i0.ɵɵtext(30, "Energy Score");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(31, "input", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 7);
        i0.ɵɵelementStart(33, "label", 19);
        i0.ɵɵtext(34, "Outlook Score");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(35, "input", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(36, "div", 7);
        i0.ɵɵelementStart(37, "label", 21);
        i0.ɵɵtext(38, "User");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "select", 22);
        i0.ɵɵelement(40, "option", 23);
        i0.ɵɵtemplate(41, SRQCompletedUpdateComponent_option_41_Template, 2, 2, "option", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(42, "div");
        i0.ɵɵelementStart(43, "button", 25);
        i0.ɵɵlistener("click", function SRQCompletedUpdateComponent_Template_button_click_43_listener() { return ctx.previousState(); });
        i0.ɵɵelement(44, "fa-icon", 26);
        i0.ɵɵtext(45, "\u00A0");
        i0.ɵɵelementStart(46, "span", 27);
        i0.ɵɵtext(47, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(48, "button", 28);
        i0.ɵɵelement(49, "fa-icon", 29);
        i0.ɵɵtext(50, "\u00A0");
        i0.ɵɵelementStart(51, "span", 30);
        i0.ɵɵtext(52, "Save");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("formGroup", ctx.editForm);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("hidden", !ctx.editForm.get("id").value);
        i0.ɵɵadvance(33);
        i0.ɵɵproperty("ngValue", null);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.users)("ngForTrackBy", ctx.trackById);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("disabled", ctx.editForm.invalid || ctx.isSaving);
    } }, directives: [i4.ɵNgNoValidate, i4.NgControlStatusGroup, i4.FormGroupDirective, i5.JhiTranslateDirective, i6.AlertErrorComponent, i4.DefaultValueAccessor, i4.NgControlStatus, i4.FormControlName, i4.NumberValueAccessor, i4.SelectControlValueAccessor, i4.NgSelectOption, i4.ɵNgSelectMultipleOption, i7.NgForOf, i8.FaIconComponent], encapsulation: 2 });
